
import { TbBrandMongodb,
 TbBrandMysql,
 TbBrandReact, 
 TbBrandRedux,
 TbBrandNodejs, 
 TbBrandHtml5,  
 TbBrandCss3,
 TbBrandTailwind,
 TbBrandBootstrap,
 TbBrandJavascript,
 TbBrandTypescript,
 TbBrandVscode
} from "react-icons/tb";
import { SiExpress, SiMocha, SiJest, SiPython  } from "react-icons/si";
import { BsFiletypeScss } from "react-icons/bs";
import { FaJava,
    FaGitAlt,
    FaGithub
 } from "react-icons/fa";

export const TechList = [
    {
        id : 1,
        name : "MongoDB",
        icons : TbBrandMongodb
    },
    {
        id : 2,
        name : "MySql",
        icons : TbBrandMysql
    },
    {
        id : 3,
        name : "ExpressJS",
        icons : SiExpress
    },
    {
        id : 4,
        name : "ReactJS",
        icons : TbBrandReact
    },
    {
        id : 5,
        name : "Redux",
        icons : TbBrandRedux
    },
    {
        id : 6,
        name : "NodeJS",
        icons : TbBrandNodejs 
    },
    {
        id : 7,
        name : "HTML5",
        icons : TbBrandHtml5
    },
    {
        id : 8,
        name : "CSS3",
        icons : TbBrandCss3
    },
    {
        id : 9,
        name : "SCSS",
        icons : BsFiletypeScss 
    },
    {
        id : 10,
        name : "Tailwind CSS",
        icons : TbBrandTailwind 
    },
    {
        id : 11,
        name : "BootStrap",
        icons : TbBrandBootstrap
    },
    {
        id : 12,
        name : "JavaScript",
        icons : TbBrandJavascript
    },
    {
        id : 13,
        name : "TypeScript",
        icons : TbBrandTypescript
    },
    {
        id : 14,
        name : "Java",
        icons : FaJava
    },
    {
        id : 15,
        name : "Git",
        icons : FaGitAlt
    },
    {
        id : 16,
        name : "Github",
        icons : FaGithub
    },
    {
        id : 17,
        name : "Mocha",
        icons : SiMocha
    },
    {
        id : 18,
        name : "Jest",
        icons : SiJest
    },
    {
        id : 19,
        name : "VS code",
        icons : TbBrandVscode
    },
    {
        id:20,
        name : "Python",
        icons : SiPython 
    }
]
